import React, { useContext, useEffect, useState } from 'react'
import classes from '../pages/destinations/destinations.module.scss'
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import {
  calculateMarkup,
  formatAmountForDisplay,
} from '../../utils/stripe-helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCalendar,
  faChevronDown,
  faMinusCircle,
} from '@fortawesome/pro-light-svg-icons'
import DividerSvg from '../svg/Divider.svg'
import { CurrencyContext } from '../../lib/context/CurrencyContext'
import { SettingsContext } from '../../lib/context/SettingsContext'
import ApiContext from '../../utils/api-context'
import { AccordionActions } from '@material-ui/core'
import PlusCircle from '../svg/PlusCircle.svg'
import DateTimePopup from '../popups/datetime'
import OverviewPopup from '../popups/overview'
import Button from '../button'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import moment from 'moment'
import { useCookies } from 'react-cookie'
import RetreatRoom from './retreat-room'

const RetreatFeatures = ({ includes }) => {
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  return (
    <>
      <div className={classes.roomAccordion}>
        {includes.map((inc, i) => {
          // console.log(inc)
          return (
            <div className={classes.roomAccordionItem} key={i}>
              <div
                className={classes.availabilityCard}
                style={{ marginBottom: 0, paddingTop: 0 }}
              >
                {inc.gallery.length > 0 && (
                  <div className={classes.packageFeatureImage}>
                    <img src={`${inc.gallery[0].url}`} alt="" />
                  </div>
                )}

                <div className={classes.availabilityInner}>
                  <h2
                    className={classes.availabilityHeader}
                    style={{ paddingLeft: '40px' }}
                  >
                    {inc.name}
                  </h2>
                  <div className={classes.availabilityContent}>
                    <div
                      className={classes.availabilityInfo}
                      dangerouslySetInnerHTML={{ __html: inc.description }}
                    />
                    {inc.feature.length > 0 && (
                      <>
                        <DividerSvg />
                        <div
                          className={`${classes.availabilityCosts} ${classes.glance}`}
                        >
                          <h4>At a glance</h4>
                          <ul>
                            {inc.feature.map((feature, j) => {
                              return (
                                <li key={j}>
                                  <FontAwesomeIcon
                                    icon={faCheckCircle}
                                    size={'2x'}
                                  />
                                  {feature.text}
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default RetreatFeatures
